import Input from './Input';

const Textarea: typeof Input = (props) => {
  return <Input {...props} multiline />;
};

export default Textarea;
